import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-25255cde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "policy-name" }

import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import { formatTableEmpty } from '@/utils/format'
import { PropType } from 'vue/dist/vue'
import { WhiteList } from '@/views/dashboard/data-safe/usb-manage/usb-policy/usb-policy.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'white-list',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  },
  whiteList: {
    type: Array as PropType<WhiteList[]>,
    default: undefined
  },
  policyName: {
    type: String,
    default: ''
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

function handleClose () {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "append-to-body": "",
    "custom-class": "white-list-wrap",
    title: _ctx.$t('usbPolicy.usbWhitelist'),
    "model-value": __props.modelValue,
    "show-close": "",
    size: 700,
    onClose: handleClose
  }, {
    default: _withCtx(() => [
      _createVNode(ContentAdaptLayout, { class: "main-content important" }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('usbPolicy.policyNameLabel')) + _toDisplayString(__props.policyName), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            height: "100%",
            data: __props.whiteList,
            "empty-text": _ctx.$t('common.noData')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "peripheral_id",
                label: _ctx.$t('usbPolicy.deviceId'),
                formatter: _unref(formatTableEmpty)
              }, null, 8, ["label", "formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "remark",
                label: _ctx.$t('usbPolicy.remark'),
                formatter: _unref(formatTableEmpty)
              }, null, 8, ["label", "formatter"])
            ]),
            _: 1
          }, 8, ["data", "empty-text"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "model-value"]))
}
}

})